import React, { useState, useRef, useContext } from 'react';
import EmpresaContext from "../../../contexts/Empresa";
import api from "../../../services/api";
import NotificationAlert from "react-notification-alert";

import Filters from './Filters'
import Table from './Table'
import {
    Card,
    CardBody,
    CardHeader,
    Container,
    Row,
    Col,
} from "reactstrap";
// core components
import SimpleHeader from '../../../components/Headers/SimpleHeader'

export default ({ ...props }) => {

    const { empresaSelecionada } = useContext(EmpresaContext)
    const [loading, setLoading] = useState(false)
    const [alert, setAlert] = useState(null)
    const [acoes, setAcoes] = useState([])
    const [pageProperties, setPageProperties] = useState({
        total: "0",
        perPage: 10,
        page: 1,
        lastPage: 1,
        loading: false,
        sort: new Map([])
    })
    const [lastSearch, setLastSearch] = useState({})
    const notificationAlert = useRef();


    function notify(type, msg) {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
                    <span data-notify="message">
                        {msg}
                    </span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 7
        };
        if (notificationAlert) notificationAlert.current.notificationAlert(options);
    };

    async function updatePageProperties(response) {
        const { total, perPage, page, lastPage } = await response.data
        await setPageProperties({
            ...pageProperties,
            total,
            perPage,
            page,
            lastPage,
            loading: false,
        })
    }

    async function loadAcoes(page = 1,
        limit = 10,
        sortField = "quando",
        sortOrder = "asc",
        filters = lastSearch) {
        try {
            setPageProperties({
                ...pageProperties,
                loading: true
            })
            //const response = await api.get(`common/empresas/${empresaSelecionada?.id}/esteiras/`, {
            const response = await api.get(`mentoring/acoesnew/`, {
                params: {
                    page,
                    limit,
                    sortField,
                    sortOrder,
                    ...filters
                }
            })
            //setEsteiras(response.data.data)
            setAcoes(response.data)
            await updatePageProperties(response)
        } catch (err) {
            console.log(err.response)
            try {
                if (err.response.data.message) {
                    notify('danger', err.response.data.message);
                } else {
                    notify('danger', 'Houve um problema ao carregar as Ações.');
                }
            } catch (error) {
                notify('danger', 'Houve um problema ao carregar as Ações.');
            }
        }
    }

    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder, ...props }) => {
        try {
            if (type == 'sort') {
                const value = pageProperties.sort.get(sortField)
                const newOrder = (value || 'asc') == 'desc' ? 'asc' : 'desc'
                const map = pageProperties.sort
                map.set(sortField, newOrder)
                sortOrder = newOrder
            }
            await loadAcoes(page == 0 ? 1 : page, sizePerPage, sortField, sortOrder)
        } catch (error) {
            console.error(error)
            notify('danger', 'Houve um problema ao carregar as ações.');
        }
    }


    return (
        <>
            {alert}
            <div className="rna-wrapper">
                <NotificationAlert ref={notificationAlert} />
            </div>
            <SimpleHeader name="Listagem de Ações" parentName="Ações" {...props} />
            <div className="w-100">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 100,
                                }}>
                                <Filters
                                    title={<h1>Ações de PDCAs</h1>}
                                    load={(filters) => {
                                        setLastSearch(filters)
                                        loadAcoes(
                                            1,
                                            10,
                                            "quando",
                                            "desc",
                                            filters)
                                    }}
                                    notify={notify}
                                />
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col>
                                        <Table
                                            acoes={acoes ? acoes.data : []}
                                            notify={notify}
                                            onTableChange={handleTableChange}
                                            history={props.history}
                                            pageProperties={pageProperties}
                                            loading={loading}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}
